import { CommonModule, DatePipe, NgClass, AsyncPipe } from "@angular/common";
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { NgSelectModule, NgSelectComponent } from "@ng-select/ng-select";
import { GlobalMessageService, GlobalMessageType, I18nModule, SiteAdapter, TranslatePipe } from "@spartacus/core";
import { FormErrorsModule, FormErrorsComponent } from "@spartacus/storefront";
import { map, Observable, Subscription, take } from "rxjs";
import { CheckoutFlowService } from "src/app/knbr-dual-checkout/checkout-flow-service";
import { KnBrCheckoutService } from "src/app/services/kn-br-checkout-service";
declare const $XIFrame: any;
@Component({
    selector: "knbr-cwt-checkout-payment",
    templateUrl: "./cwt-checkout-payment.component.html",
    imports: [
        NgClass,
        ReactiveFormsModule,
        FormsModule,
        FormErrorsComponent,
        NgSelectComponent,
        AsyncPipe,
        TranslatePipe,
    ],
})
export class CwtCheckoutPaymentComponent implements OnInit, OnDestroy {
  customerName: string;
  customerNumber: string;
  currentUrl = "";
  allSubscriptions = new Subscription();
  payMetricIframeSource;
  accessTokenValue;
  paramMap = {};
  billingForm: FormGroup;
  stateData: any[];
  paymentAddress: any = {};
  firstName: any = "";
  lastName: any = "";
  regionValue: any = "";
  townValue: any = "";
  line1Value: any = "";
  zipCodeValue: any = "";
  isPayment: boolean = true;
  cardInfo = {
    cardNumber: "",
    expiryYear: "",
    expiryMonth: "",
  };
  disableAccountOption = false;
  billingFormInvalid = false;

  constructor(
    private checkoutService: KnBrCheckoutService,
    private checkoutFlowService: CheckoutFlowService,
    private router: Router,
    private datePipe: DatePipe,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private siteAdapter: SiteAdapter,
    protected globalMessageService: GlobalMessageService
  ) {
    this.currentUrl = this.router.url;
    if (this.currentUrl.includes("/checkout")) {
      this.checkoutService.isCheckout$.next(true);
    }

    const regionSub= this.siteAdapter.loadRegions("US").subscribe((res) => {
      if (res) {
        this.stateData = res.filter((eachItem) => eachItem.isocode.startsWith("US"));
        this.cdr.detectChanges()
      }
    });
    this.allSubscriptions.add(regionSub);
  }

  ngOnInit(): void {
    const contextStr = localStorage.getItem("kn-br-customer-context");
    if (contextStr) {
      const context = JSON.parse(contextStr);
      this.customerName = context.customerName || "";
      this.customerNumber = context.customerNumber || "";
    }
    this.checkoutFlowService.getCart().subscribe((cartResp) => {
      this.paymentAddress = cartResp?.paymentAddress || {};
      if (cartResp.deliveryContactInfo.pickUpType === "IMMEDIATE") {
        this.checkoutFlowService.setSelectedDate("Immediate Pickup");
      } else if (cartResp.deliveryContactInfo.scheduledDeliveryDate) {
        const date = this.datePipe.transform(
          cartResp.deliveryContactInfo.scheduledDeliveryDate,
          "MMMM d, y"
        );
        this.checkoutFlowService.setSelectedDate(date);
      }
    });
  }

  paymentTypes$: Observable<any[]> = this.checkoutService
    .getPaymentTypes()
    .pipe(map((res: any) => (res.paymentTypes || []).slice().reverse()));

  selectedPaymentMethod: string = "";

  onPaymentChange(method: string) {
    this.selectedPaymentMethod = method;
    this.checkoutService.setPaymentType(method).pipe(take(1)).subscribe((res:any) => {
      console.log(res)
      if(res?.cwtPaymentType.code == "ACCOUNT"){ 
        this.checkoutService.setPlaceOrderDisableFlag(false)
      }
      else if(res?.cwtPaymentType.code === "CARD"){
        this.checkoutService.setPlaceOrderDisableFlag(true)
          }
     }, err => {});

    if (method === "CARD") {
      this.initForm();
      this.allSubscriptions.add(
        this.checkoutService.getPayMetricIframeUrl().subscribe((resp: any) => {
          this.payMetricIframeSource =
            this.sanitizer.bypassSecurityTrustResourceUrl(
              resp.paymetricIframeSrc
            );
          this.accessTokenValue = resp.accessToken;
          if (resp?.paymentData?.parameters) {
            resp.paymentData.parameters.entry.forEach(({ key, value }) => {
              this.paramMap[key] = value;
            });
          }
          this.addnewScriptTagPaymentric(resp.paymetricXiUrl);
          this.cdr.detectChanges();
        }, err => {
          this.globalMessageService.add(
            "We're unable to load the payment section currently, please try again shortly.",
            GlobalMessageType.MSG_TYPE_ERROR
          );
        })
      );

      this.allSubscriptions.add(
         this.billingForm.statusChanges.subscribe(status => {
          if (status === 'VALID') {
            this.billingFormInvalid = false;
          } else {
            this.billingFormInvalid = true;
          }
        })
      )
    }
  }

  addnewScriptTagPaymentric(scriptUrl) {
    const scriptElement = document.createElement("script");
    scriptElement.type = "text/javascript";
    scriptElement.src = scriptUrl + "/scripts/XIFrame/XIFrame-1.2.0.js";
    scriptElement.async = true;
    scriptElement.defer = true;
    document.head.appendChild(scriptElement);
  }

  submitServiceForm(event: MouseEvent) {
    if (this.billingForm.status === "INVALID") {
      this.billingFormInvalid = true;
    } else {
      if(event.detail > 1) {
        return;
      } else {
        const iframe = document.getElementsByName("xieCommFrame");
        if (iframe) {
          $XIFrame.submit({
            iFrameId: "xieCommFrame",
            targetUrl: iframe[0].getAttribute("src"),
            onSuccess: this.onSubmitServiceSuccess,
            onError: this.onSubmitServiceError,
          });
        }
      }
    }
  }

  onSubmitServiceSuccess = (msg) => {
    const { firstName, lastName, region, town, line1, postalCode } = this.billingForm?.value;
    this.firstName = firstName;
    this.lastName = lastName;
    this.regionValue = region;
    this.townValue = town;
    this.line1Value = line1;
    this.zipCodeValue = postalCode;

    const country = { isocode: 'US' };
    this.billingForm.value.region = { isocode: region };
    this.billingForm.value.country = country;
    if (this.billingForm.valid) {
      this.checkoutService.setBillingAddress(this.customerNumber, this.billingForm?.value);
    }

    const message = JSON.parse(msg);
    if (message && message.data.HasPassed) {
      document.getElementById("cmdSubmit")?.click();
      this.saveTheCreditCardDetails();
    } else {
      alert(message.data.Message);
    }
  };

  saveTheCreditCardDetails() {
    const payloadData = {
      billTo_firstName: this.firstName,
      billTo_city: this.townValue,
      billTo_email: this.paramMap["billTo_email"],
      billTo_titleCode: this.paramMap["billTo_titleCode"],
      billTo_country: 'US',
      billTo_lastName: this.lastName,
      billTo_street1: this.line1Value,
      currency: this.paramMap["currency"],
      amount: this.paramMap["amount"],
      billTo_postalCode: this.zipCodeValue,
      billTo_state: this.regionValue,
    };
    this.allSubscriptions.add(
      this.checkoutService
        .saveTheCreditCardDetails(this.accessTokenValue, payloadData)
        .subscribe({
          next: (respData: any) => {
            if (respData.success === true) {
              this.isPayment = false;
              this.getUpdatedCartDetailsApi();
              this.checkoutService.setPlaceOrderDisableFlag(false);
            }
            console.log(
              "logging the save credit card details api response data",
              respData
            );
          },
          error: (err) => {
            console.error("Error while saving credit card details:", err);
            this.globalMessageService.add(
              "We couldn’t process your payment. Please try again.",
              GlobalMessageType.MSG_TYPE_ERROR
            );
          },
        })
    );
  }


  getUpdatedCartDetailsApi() {
    this.allSubscriptions.add(
      this.checkoutFlowService.fetchAndSetModeFromApi().subscribe(resp => {
        if(resp?.paymentInfo?.cardNumber) {
          this.checkoutFlowService.setCreditCardPaymentSuccess(true);
          this.cardInfo = {
            cardNumber : this.extractMiddleDigits(resp.paymentInfo.cardNumber),
            expiryMonth: resp.paymentInfo.expiryMonth,
            expiryYear: resp.paymentInfo.expiryYear
          }
          this.disableAccountOption = true;
          this.cdr.detectChanges()
        }
      })
    )
  }

  onSubmitServiceError = (msg) => {
    console.log(msg);
  };

  isInvalid(controlName: string): boolean {
    const control = this.billingForm?.get(controlName);
    return !!(control && control.invalid && control.touched);
  }

  initForm(): void {
    this.billingForm = this.fb.group({
      firstName: [this.paymentAddress?.firstName || '', Validators.required],
      lastName: [this.paymentAddress?.lastName || '', Validators.required],
      line1: [this.paymentAddress?.line1 || '', Validators.required],
      line2: [this.paymentAddress?.line2 || ''],
      town: [this.paymentAddress?.town || '', Validators.required],
      region: [this.paymentAddress?.region?.isocode || '', Validators.required],
      postalCode: [this.trimPostalCode(this.paymentAddress?.postalCode) || '', Validators.required],
    });
  }

  trimPostalCode(zipcode) {
     if (zipcode) {
    return zipcode.length > 5 ? zipcode.substring(0, 5) : zipcode;
  }
  return zipcode; 
}

  extractMiddleDigits(str) {
    const match = str.match(/-(\d+)-/);
    return match ? match[1] : null;
  }

  ngOnDestroy(): void {
    this.checkoutFlowService.setCreditCardPaymentSuccess(false)
    this.allSubscriptions?.unsubscribe();
    this.payMetricIframeSource = "";
    this.accessTokenValue = "";
  }
}
